/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsImport } from './routes/terms'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as errors503Import } from './routes/(errors)/503'
import { Route as errors500Import } from './routes/(errors)/500'
import { Route as errors404Import } from './routes/(errors)/404'
import { Route as errors403Import } from './routes/(errors)/403'
import { Route as errors401Import } from './routes/(errors)/401'
import { Route as authSignUpImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2Import } from './routes/(auth)/sign-in-2'
import { Route as authSignInImport } from './routes/(auth)/sign-in'
import { Route as authForgotPasswordImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedApiSettingsRouteImport } from './routes/_authenticated/api-settings/route'
import { Route as AuthenticatedVillesIndexImport } from './routes/_authenticated/villes/index'
import { Route as AuthenticatedTrackingStatesIndexImport } from './routes/_authenticated/tracking-states/index'
import { Route as AuthenticatedStocksIndexImport } from './routes/_authenticated/stocks/index'
import { Route as AuthenticatedShippingIndexImport } from './routes/_authenticated/shipping/index'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRammasageIndexImport } from './routes/_authenticated/rammasage/index'
import { Route as AuthenticatedPackagingIndexImport } from './routes/_authenticated/packaging/index'
import { Route as AuthenticatedModerateursIndexImport } from './routes/_authenticated/moderateurs/index'
import { Route as AuthenticatedLivreursIndexImport } from './routes/_authenticated/livreurs/index'
import { Route as AuthenticatedLivreursFeeIndexImport } from './routes/_authenticated/livreurs-fee/index'
import { Route as AuthenticatedHelpCenterIndexImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedFacturesLivraisonIndexImport } from './routes/_authenticated/factures-livraison/index'
import { Route as AuthenticatedFacturesClientsIndexImport } from './routes/_authenticated/factures-clients/index'
import { Route as AuthenticatedCommandsIndexImport } from './routes/_authenticated/commands/index'
import { Route as AuthenticatedCommandsUpdatedTodayIndexImport } from './routes/_authenticated/commands-updated-today/index'
import { Route as AuthenticatedCommandsSansLivreurIndexImport } from './routes/_authenticated/commands-sans-livreur/index'
import { Route as AuthenticatedCommandsLivresIndexImport } from './routes/_authenticated/commands-livres/index'
import { Route as AuthenticatedCommandsEnCoursIndexImport } from './routes/_authenticated/commands-en-cours/index'
import { Route as AuthenticatedCommandsEchoueIndexImport } from './routes/_authenticated/commands-echoue/index'
import { Route as AuthenticatedCommandsChangeIndexImport } from './routes/_authenticated/commands-change/index'
import { Route as AuthenticatedClientsIndexImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedClientsFeeIndexImport } from './routes/_authenticated/clients-fee/index'
import { Route as AuthenticatedChatsIndexImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedBonRetourLivreurIndexImport } from './routes/_authenticated/bon-retour-livreur/index'
import { Route as AuthenticatedBonRetourClientIndexImport } from './routes/_authenticated/bon-retour-client/index'
import { Route as AuthenticatedBonLivraisonIndexImport } from './routes/_authenticated/bon-livraison/index'
import { Route as AuthenticatedAppsIndexImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAnnouncesIndexImport } from './routes/_authenticated/announces/index'
import { Route as AuthenticatedAffectationIndexImport } from './routes/_authenticated/affectation/index'
import { Route as AuthenticatedSettingsNotificationsImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedApiSettingsKeysImport } from './routes/_authenticated/api-settings/keys'
import { Route as AuthenticatedApiSettingsDocImport } from './routes/_authenticated/api-settings/doc'

// Create/Update Routes

const TermsRoute = TermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const errors503Route = errors503Import.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRoute,
} as any)

const errors500Route = errors500Import.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRoute,
} as any)

const errors404Route = errors404Import.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRoute,
} as any)

const errors403Route = errors403Import.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRoute,
} as any)

const errors401Route = errors401Import.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRoute,
} as any)

const authSignUpRoute = authSignUpImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const authSignIn2Route = authSignIn2Import.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRoute,
} as any)

const authSignInRoute = authSignInImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordRoute = authForgotPasswordImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSettingsRouteRoute = AuthenticatedSettingsRouteImport.update(
  {
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedApiSettingsRouteRoute =
  AuthenticatedApiSettingsRouteImport.update({
    id: '/api-settings',
    path: '/api-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedVillesIndexRoute = AuthenticatedVillesIndexImport.update({
  id: '/villes/',
  path: '/villes/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedTrackingStatesIndexRoute =
  AuthenticatedTrackingStatesIndexImport.update({
    id: '/tracking-states/',
    path: '/tracking-states/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedStocksIndexRoute = AuthenticatedStocksIndexImport.update({
  id: '/stocks/',
  path: '/stocks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedShippingIndexRoute = AuthenticatedShippingIndexImport.update(
  {
    id: '/shipping/',
    path: '/shipping/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any,
)

const AuthenticatedRammasageIndexRoute =
  AuthenticatedRammasageIndexImport.update({
    id: '/rammasage/',
    path: '/rammasage/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedPackagingIndexRoute =
  AuthenticatedPackagingIndexImport.update({
    id: '/packaging/',
    path: '/packaging/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedModerateursIndexRoute =
  AuthenticatedModerateursIndexImport.update({
    id: '/moderateurs/',
    path: '/moderateurs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedLivreursIndexRoute = AuthenticatedLivreursIndexImport.update(
  {
    id: '/livreurs/',
    path: '/livreurs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedLivreursFeeIndexRoute =
  AuthenticatedLivreursFeeIndexImport.update({
    id: '/livreurs-fee/',
    path: '/livreurs-fee/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFacturesLivraisonIndexRoute =
  AuthenticatedFacturesLivraisonIndexImport.update({
    id: '/factures-livraison/',
    path: '/factures-livraison/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedFacturesClientsIndexRoute =
  AuthenticatedFacturesClientsIndexImport.update({
    id: '/factures-clients/',
    path: '/factures-clients/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsIndexRoute = AuthenticatedCommandsIndexImport.update(
  {
    id: '/commands/',
    path: '/commands/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedCommandsUpdatedTodayIndexRoute =
  AuthenticatedCommandsUpdatedTodayIndexImport.update({
    id: '/commands-updated-today/',
    path: '/commands-updated-today/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsSansLivreurIndexRoute =
  AuthenticatedCommandsSansLivreurIndexImport.update({
    id: '/commands-sans-livreur/',
    path: '/commands-sans-livreur/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsLivresIndexRoute =
  AuthenticatedCommandsLivresIndexImport.update({
    id: '/commands-livres/',
    path: '/commands-livres/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsEnCoursIndexRoute =
  AuthenticatedCommandsEnCoursIndexImport.update({
    id: '/commands-en-cours/',
    path: '/commands-en-cours/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsEchoueIndexRoute =
  AuthenticatedCommandsEchoueIndexImport.update({
    id: '/commands-echoue/',
    path: '/commands-echoue/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCommandsChangeIndexRoute =
  AuthenticatedCommandsChangeIndexImport.update({
    id: '/commands-change/',
    path: '/commands-change/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedClientsIndexRoute = AuthenticatedClientsIndexImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedClientsFeeIndexRoute =
  AuthenticatedClientsFeeIndexImport.update({
    id: '/clients-fee/',
    path: '/clients-fee/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedBonRetourLivreurIndexRoute =
  AuthenticatedBonRetourLivreurIndexImport.update({
    id: '/bon-retour-livreur/',
    path: '/bon-retour-livreur/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedBonRetourClientIndexRoute =
  AuthenticatedBonRetourClientIndexImport.update({
    id: '/bon-retour-client/',
    path: '/bon-retour-client/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedBonLivraisonIndexRoute =
  AuthenticatedBonLivraisonIndexImport.update({
    id: '/bon-livraison/',
    path: '/bon-livraison/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedAnnouncesIndexRoute =
  AuthenticatedAnnouncesIndexImport.update({
    id: '/announces/',
    path: '/announces/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedAffectationIndexRoute =
  AuthenticatedAffectationIndexImport.update({
    id: '/affectation/',
    path: '/affectation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedApiSettingsKeysRoute =
  AuthenticatedApiSettingsKeysImport.update({
    id: '/keys',
    path: '/keys',
    getParentRoute: () => AuthenticatedApiSettingsRouteRoute,
  } as any)

const AuthenticatedApiSettingsDocRoute =
  AuthenticatedApiSettingsDocImport.update({
    id: '/doc',
    path: '/doc',
    getParentRoute: () => AuthenticatedApiSettingsRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/api-settings': {
      id: '/_authenticated/api-settings'
      path: '/api-settings'
      fullPath: '/api-settings'
      preLoaderRoute: typeof AuthenticatedApiSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2Import
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503Import
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/api-settings/doc': {
      id: '/_authenticated/api-settings/doc'
      path: '/doc'
      fullPath: '/api-settings/doc'
      preLoaderRoute: typeof AuthenticatedApiSettingsDocImport
      parentRoute: typeof AuthenticatedApiSettingsRouteImport
    }
    '/_authenticated/api-settings/keys': {
      id: '/_authenticated/api-settings/keys'
      path: '/keys'
      fullPath: '/api-settings/keys'
      preLoaderRoute: typeof AuthenticatedApiSettingsKeysImport
      parentRoute: typeof AuthenticatedApiSettingsRouteImport
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/affectation/': {
      id: '/_authenticated/affectation/'
      path: '/affectation'
      fullPath: '/affectation'
      preLoaderRoute: typeof AuthenticatedAffectationIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/announces/': {
      id: '/_authenticated/announces/'
      path: '/announces'
      fullPath: '/announces'
      preLoaderRoute: typeof AuthenticatedAnnouncesIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/bon-livraison/': {
      id: '/_authenticated/bon-livraison/'
      path: '/bon-livraison'
      fullPath: '/bon-livraison'
      preLoaderRoute: typeof AuthenticatedBonLivraisonIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/bon-retour-client/': {
      id: '/_authenticated/bon-retour-client/'
      path: '/bon-retour-client'
      fullPath: '/bon-retour-client'
      preLoaderRoute: typeof AuthenticatedBonRetourClientIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/bon-retour-livreur/': {
      id: '/_authenticated/bon-retour-livreur/'
      path: '/bon-retour-livreur'
      fullPath: '/bon-retour-livreur'
      preLoaderRoute: typeof AuthenticatedBonRetourLivreurIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/clients-fee/': {
      id: '/_authenticated/clients-fee/'
      path: '/clients-fee'
      fullPath: '/clients-fee'
      preLoaderRoute: typeof AuthenticatedClientsFeeIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-change/': {
      id: '/_authenticated/commands-change/'
      path: '/commands-change'
      fullPath: '/commands-change'
      preLoaderRoute: typeof AuthenticatedCommandsChangeIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-echoue/': {
      id: '/_authenticated/commands-echoue/'
      path: '/commands-echoue'
      fullPath: '/commands-echoue'
      preLoaderRoute: typeof AuthenticatedCommandsEchoueIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-en-cours/': {
      id: '/_authenticated/commands-en-cours/'
      path: '/commands-en-cours'
      fullPath: '/commands-en-cours'
      preLoaderRoute: typeof AuthenticatedCommandsEnCoursIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-livres/': {
      id: '/_authenticated/commands-livres/'
      path: '/commands-livres'
      fullPath: '/commands-livres'
      preLoaderRoute: typeof AuthenticatedCommandsLivresIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-sans-livreur/': {
      id: '/_authenticated/commands-sans-livreur/'
      path: '/commands-sans-livreur'
      fullPath: '/commands-sans-livreur'
      preLoaderRoute: typeof AuthenticatedCommandsSansLivreurIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands-updated-today/': {
      id: '/_authenticated/commands-updated-today/'
      path: '/commands-updated-today'
      fullPath: '/commands-updated-today'
      preLoaderRoute: typeof AuthenticatedCommandsUpdatedTodayIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/commands/': {
      id: '/_authenticated/commands/'
      path: '/commands'
      fullPath: '/commands'
      preLoaderRoute: typeof AuthenticatedCommandsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/factures-clients/': {
      id: '/_authenticated/factures-clients/'
      path: '/factures-clients'
      fullPath: '/factures-clients'
      preLoaderRoute: typeof AuthenticatedFacturesClientsIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/factures-livraison/': {
      id: '/_authenticated/factures-livraison/'
      path: '/factures-livraison'
      fullPath: '/factures-livraison'
      preLoaderRoute: typeof AuthenticatedFacturesLivraisonIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/livreurs-fee/': {
      id: '/_authenticated/livreurs-fee/'
      path: '/livreurs-fee'
      fullPath: '/livreurs-fee'
      preLoaderRoute: typeof AuthenticatedLivreursFeeIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/livreurs/': {
      id: '/_authenticated/livreurs/'
      path: '/livreurs'
      fullPath: '/livreurs'
      preLoaderRoute: typeof AuthenticatedLivreursIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/moderateurs/': {
      id: '/_authenticated/moderateurs/'
      path: '/moderateurs'
      fullPath: '/moderateurs'
      preLoaderRoute: typeof AuthenticatedModerateursIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/packaging/': {
      id: '/_authenticated/packaging/'
      path: '/packaging'
      fullPath: '/packaging'
      preLoaderRoute: typeof AuthenticatedPackagingIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/rammasage/': {
      id: '/_authenticated/rammasage/'
      path: '/rammasage'
      fullPath: '/rammasage'
      preLoaderRoute: typeof AuthenticatedRammasageIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/shipping/': {
      id: '/_authenticated/shipping/'
      path: '/shipping'
      fullPath: '/shipping'
      preLoaderRoute: typeof AuthenticatedShippingIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/stocks/': {
      id: '/_authenticated/stocks/'
      path: '/stocks'
      fullPath: '/stocks'
      preLoaderRoute: typeof AuthenticatedStocksIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/tracking-states/': {
      id: '/_authenticated/tracking-states/'
      path: '/tracking-states'
      fullPath: '/tracking-states'
      preLoaderRoute: typeof AuthenticatedTrackingStatesIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/villes/': {
      id: '/_authenticated/villes/'
      path: '/villes'
      fullPath: '/villes'
      preLoaderRoute: typeof AuthenticatedVillesIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedApiSettingsRouteRouteChildren {
  AuthenticatedApiSettingsDocRoute: typeof AuthenticatedApiSettingsDocRoute
  AuthenticatedApiSettingsKeysRoute: typeof AuthenticatedApiSettingsKeysRoute
}

const AuthenticatedApiSettingsRouteRouteChildren: AuthenticatedApiSettingsRouteRouteChildren =
  {
    AuthenticatedApiSettingsDocRoute: AuthenticatedApiSettingsDocRoute,
    AuthenticatedApiSettingsKeysRoute: AuthenticatedApiSettingsKeysRoute,
  }

const AuthenticatedApiSettingsRouteRouteWithChildren =
  AuthenticatedApiSettingsRouteRoute._addFileChildren(
    AuthenticatedApiSettingsRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedApiSettingsRouteRoute: typeof AuthenticatedApiSettingsRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAffectationIndexRoute: typeof AuthenticatedAffectationIndexRoute
  AuthenticatedAnnouncesIndexRoute: typeof AuthenticatedAnnouncesIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedBonLivraisonIndexRoute: typeof AuthenticatedBonLivraisonIndexRoute
  AuthenticatedBonRetourClientIndexRoute: typeof AuthenticatedBonRetourClientIndexRoute
  AuthenticatedBonRetourLivreurIndexRoute: typeof AuthenticatedBonRetourLivreurIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedClientsFeeIndexRoute: typeof AuthenticatedClientsFeeIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedCommandsChangeIndexRoute: typeof AuthenticatedCommandsChangeIndexRoute
  AuthenticatedCommandsEchoueIndexRoute: typeof AuthenticatedCommandsEchoueIndexRoute
  AuthenticatedCommandsEnCoursIndexRoute: typeof AuthenticatedCommandsEnCoursIndexRoute
  AuthenticatedCommandsLivresIndexRoute: typeof AuthenticatedCommandsLivresIndexRoute
  AuthenticatedCommandsSansLivreurIndexRoute: typeof AuthenticatedCommandsSansLivreurIndexRoute
  AuthenticatedCommandsUpdatedTodayIndexRoute: typeof AuthenticatedCommandsUpdatedTodayIndexRoute
  AuthenticatedCommandsIndexRoute: typeof AuthenticatedCommandsIndexRoute
  AuthenticatedFacturesClientsIndexRoute: typeof AuthenticatedFacturesClientsIndexRoute
  AuthenticatedFacturesLivraisonIndexRoute: typeof AuthenticatedFacturesLivraisonIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedLivreursFeeIndexRoute: typeof AuthenticatedLivreursFeeIndexRoute
  AuthenticatedLivreursIndexRoute: typeof AuthenticatedLivreursIndexRoute
  AuthenticatedModerateursIndexRoute: typeof AuthenticatedModerateursIndexRoute
  AuthenticatedPackagingIndexRoute: typeof AuthenticatedPackagingIndexRoute
  AuthenticatedRammasageIndexRoute: typeof AuthenticatedRammasageIndexRoute
  AuthenticatedShippingIndexRoute: typeof AuthenticatedShippingIndexRoute
  AuthenticatedStocksIndexRoute: typeof AuthenticatedStocksIndexRoute
  AuthenticatedTrackingStatesIndexRoute: typeof AuthenticatedTrackingStatesIndexRoute
  AuthenticatedVillesIndexRoute: typeof AuthenticatedVillesIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedApiSettingsRouteRoute:
    AuthenticatedApiSettingsRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAffectationIndexRoute: AuthenticatedAffectationIndexRoute,
  AuthenticatedAnnouncesIndexRoute: AuthenticatedAnnouncesIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedBonLivraisonIndexRoute: AuthenticatedBonLivraisonIndexRoute,
  AuthenticatedBonRetourClientIndexRoute:
    AuthenticatedBonRetourClientIndexRoute,
  AuthenticatedBonRetourLivreurIndexRoute:
    AuthenticatedBonRetourLivreurIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedClientsFeeIndexRoute: AuthenticatedClientsFeeIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedCommandsChangeIndexRoute: AuthenticatedCommandsChangeIndexRoute,
  AuthenticatedCommandsEchoueIndexRoute: AuthenticatedCommandsEchoueIndexRoute,
  AuthenticatedCommandsEnCoursIndexRoute:
    AuthenticatedCommandsEnCoursIndexRoute,
  AuthenticatedCommandsLivresIndexRoute: AuthenticatedCommandsLivresIndexRoute,
  AuthenticatedCommandsSansLivreurIndexRoute:
    AuthenticatedCommandsSansLivreurIndexRoute,
  AuthenticatedCommandsUpdatedTodayIndexRoute:
    AuthenticatedCommandsUpdatedTodayIndexRoute,
  AuthenticatedCommandsIndexRoute: AuthenticatedCommandsIndexRoute,
  AuthenticatedFacturesClientsIndexRoute:
    AuthenticatedFacturesClientsIndexRoute,
  AuthenticatedFacturesLivraisonIndexRoute:
    AuthenticatedFacturesLivraisonIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedLivreursFeeIndexRoute: AuthenticatedLivreursFeeIndexRoute,
  AuthenticatedLivreursIndexRoute: AuthenticatedLivreursIndexRoute,
  AuthenticatedModerateursIndexRoute: AuthenticatedModerateursIndexRoute,
  AuthenticatedPackagingIndexRoute: AuthenticatedPackagingIndexRoute,
  AuthenticatedRammasageIndexRoute: AuthenticatedRammasageIndexRoute,
  AuthenticatedShippingIndexRoute: AuthenticatedShippingIndexRoute,
  AuthenticatedStocksIndexRoute: AuthenticatedStocksIndexRoute,
  AuthenticatedTrackingStatesIndexRoute: AuthenticatedTrackingStatesIndexRoute,
  AuthenticatedVillesIndexRoute: AuthenticatedVillesIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/api-settings': typeof AuthenticatedApiSettingsRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/api-settings/doc': typeof AuthenticatedApiSettingsDocRoute
  '/api-settings/keys': typeof AuthenticatedApiSettingsKeysRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/affectation': typeof AuthenticatedAffectationIndexRoute
  '/announces': typeof AuthenticatedAnnouncesIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/bon-livraison': typeof AuthenticatedBonLivraisonIndexRoute
  '/bon-retour-client': typeof AuthenticatedBonRetourClientIndexRoute
  '/bon-retour-livreur': typeof AuthenticatedBonRetourLivreurIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/clients-fee': typeof AuthenticatedClientsFeeIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/commands-change': typeof AuthenticatedCommandsChangeIndexRoute
  '/commands-echoue': typeof AuthenticatedCommandsEchoueIndexRoute
  '/commands-en-cours': typeof AuthenticatedCommandsEnCoursIndexRoute
  '/commands-livres': typeof AuthenticatedCommandsLivresIndexRoute
  '/commands-sans-livreur': typeof AuthenticatedCommandsSansLivreurIndexRoute
  '/commands-updated-today': typeof AuthenticatedCommandsUpdatedTodayIndexRoute
  '/commands': typeof AuthenticatedCommandsIndexRoute
  '/factures-clients': typeof AuthenticatedFacturesClientsIndexRoute
  '/factures-livraison': typeof AuthenticatedFacturesLivraisonIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/livreurs-fee': typeof AuthenticatedLivreursFeeIndexRoute
  '/livreurs': typeof AuthenticatedLivreursIndexRoute
  '/moderateurs': typeof AuthenticatedModerateursIndexRoute
  '/packaging': typeof AuthenticatedPackagingIndexRoute
  '/rammasage': typeof AuthenticatedRammasageIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/shipping': typeof AuthenticatedShippingIndexRoute
  '/stocks': typeof AuthenticatedStocksIndexRoute
  '/tracking-states': typeof AuthenticatedTrackingStatesIndexRoute
  '/villes': typeof AuthenticatedVillesIndexRoute
}

export interface FileRoutesByTo {
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/api-settings': typeof AuthenticatedApiSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/api-settings/doc': typeof AuthenticatedApiSettingsDocRoute
  '/api-settings/keys': typeof AuthenticatedApiSettingsKeysRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/affectation': typeof AuthenticatedAffectationIndexRoute
  '/announces': typeof AuthenticatedAnnouncesIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/bon-livraison': typeof AuthenticatedBonLivraisonIndexRoute
  '/bon-retour-client': typeof AuthenticatedBonRetourClientIndexRoute
  '/bon-retour-livreur': typeof AuthenticatedBonRetourLivreurIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/clients-fee': typeof AuthenticatedClientsFeeIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/commands-change': typeof AuthenticatedCommandsChangeIndexRoute
  '/commands-echoue': typeof AuthenticatedCommandsEchoueIndexRoute
  '/commands-en-cours': typeof AuthenticatedCommandsEnCoursIndexRoute
  '/commands-livres': typeof AuthenticatedCommandsLivresIndexRoute
  '/commands-sans-livreur': typeof AuthenticatedCommandsSansLivreurIndexRoute
  '/commands-updated-today': typeof AuthenticatedCommandsUpdatedTodayIndexRoute
  '/commands': typeof AuthenticatedCommandsIndexRoute
  '/factures-clients': typeof AuthenticatedFacturesClientsIndexRoute
  '/factures-livraison': typeof AuthenticatedFacturesLivraisonIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/livreurs-fee': typeof AuthenticatedLivreursFeeIndexRoute
  '/livreurs': typeof AuthenticatedLivreursIndexRoute
  '/moderateurs': typeof AuthenticatedModerateursIndexRoute
  '/packaging': typeof AuthenticatedPackagingIndexRoute
  '/rammasage': typeof AuthenticatedRammasageIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/shipping': typeof AuthenticatedShippingIndexRoute
  '/stocks': typeof AuthenticatedStocksIndexRoute
  '/tracking-states': typeof AuthenticatedTrackingStatesIndexRoute
  '/villes': typeof AuthenticatedVillesIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_authenticated/api-settings': typeof AuthenticatedApiSettingsRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/api-settings/doc': typeof AuthenticatedApiSettingsDocRoute
  '/_authenticated/api-settings/keys': typeof AuthenticatedApiSettingsKeysRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/affectation/': typeof AuthenticatedAffectationIndexRoute
  '/_authenticated/announces/': typeof AuthenticatedAnnouncesIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/bon-livraison/': typeof AuthenticatedBonLivraisonIndexRoute
  '/_authenticated/bon-retour-client/': typeof AuthenticatedBonRetourClientIndexRoute
  '/_authenticated/bon-retour-livreur/': typeof AuthenticatedBonRetourLivreurIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/clients-fee/': typeof AuthenticatedClientsFeeIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/commands-change/': typeof AuthenticatedCommandsChangeIndexRoute
  '/_authenticated/commands-echoue/': typeof AuthenticatedCommandsEchoueIndexRoute
  '/_authenticated/commands-en-cours/': typeof AuthenticatedCommandsEnCoursIndexRoute
  '/_authenticated/commands-livres/': typeof AuthenticatedCommandsLivresIndexRoute
  '/_authenticated/commands-sans-livreur/': typeof AuthenticatedCommandsSansLivreurIndexRoute
  '/_authenticated/commands-updated-today/': typeof AuthenticatedCommandsUpdatedTodayIndexRoute
  '/_authenticated/commands/': typeof AuthenticatedCommandsIndexRoute
  '/_authenticated/factures-clients/': typeof AuthenticatedFacturesClientsIndexRoute
  '/_authenticated/factures-livraison/': typeof AuthenticatedFacturesLivraisonIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/livreurs-fee/': typeof AuthenticatedLivreursFeeIndexRoute
  '/_authenticated/livreurs/': typeof AuthenticatedLivreursIndexRoute
  '/_authenticated/moderateurs/': typeof AuthenticatedModerateursIndexRoute
  '/_authenticated/packaging/': typeof AuthenticatedPackagingIndexRoute
  '/_authenticated/rammasage/': typeof AuthenticatedRammasageIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/shipping/': typeof AuthenticatedShippingIndexRoute
  '/_authenticated/stocks/': typeof AuthenticatedStocksIndexRoute
  '/_authenticated/tracking-states/': typeof AuthenticatedTrackingStatesIndexRoute
  '/_authenticated/villes/': typeof AuthenticatedVillesIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/privacy'
    | '/terms'
    | '/api-settings'
    | '/settings'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/api-settings/doc'
    | '/api-settings/keys'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/affectation'
    | '/announces'
    | '/apps'
    | '/bon-livraison'
    | '/bon-retour-client'
    | '/bon-retour-livreur'
    | '/chats'
    | '/clients-fee'
    | '/clients'
    | '/commands-change'
    | '/commands-echoue'
    | '/commands-en-cours'
    | '/commands-livres'
    | '/commands-sans-livreur'
    | '/commands-updated-today'
    | '/commands'
    | '/factures-clients'
    | '/factures-livraison'
    | '/help-center'
    | '/livreurs-fee'
    | '/livreurs'
    | '/moderateurs'
    | '/packaging'
    | '/rammasage'
    | '/settings/'
    | '/shipping'
    | '/stocks'
    | '/tracking-states'
    | '/villes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/privacy'
    | '/terms'
    | '/api-settings'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/api-settings/doc'
    | '/api-settings/keys'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/affectation'
    | '/announces'
    | '/apps'
    | '/bon-livraison'
    | '/bon-retour-client'
    | '/bon-retour-livreur'
    | '/chats'
    | '/clients-fee'
    | '/clients'
    | '/commands-change'
    | '/commands-echoue'
    | '/commands-en-cours'
    | '/commands-livres'
    | '/commands-sans-livreur'
    | '/commands-updated-today'
    | '/commands'
    | '/factures-clients'
    | '/factures-livraison'
    | '/help-center'
    | '/livreurs-fee'
    | '/livreurs'
    | '/moderateurs'
    | '/packaging'
    | '/rammasage'
    | '/settings'
    | '/shipping'
    | '/stocks'
    | '/tracking-states'
    | '/villes'
  id:
    | '__root__'
    | '/_authenticated'
    | '/privacy'
    | '/terms'
    | '/_authenticated/api-settings'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/api-settings/doc'
    | '/_authenticated/api-settings/keys'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/affectation/'
    | '/_authenticated/announces/'
    | '/_authenticated/apps/'
    | '/_authenticated/bon-livraison/'
    | '/_authenticated/bon-retour-client/'
    | '/_authenticated/bon-retour-livreur/'
    | '/_authenticated/chats/'
    | '/_authenticated/clients-fee/'
    | '/_authenticated/clients/'
    | '/_authenticated/commands-change/'
    | '/_authenticated/commands-echoue/'
    | '/_authenticated/commands-en-cours/'
    | '/_authenticated/commands-livres/'
    | '/_authenticated/commands-sans-livreur/'
    | '/_authenticated/commands-updated-today/'
    | '/_authenticated/commands/'
    | '/_authenticated/factures-clients/'
    | '/_authenticated/factures-livraison/'
    | '/_authenticated/help-center/'
    | '/_authenticated/livreurs-fee/'
    | '/_authenticated/livreurs/'
    | '/_authenticated/moderateurs/'
    | '/_authenticated/packaging/'
    | '/_authenticated/rammasage/'
    | '/_authenticated/settings/'
    | '/_authenticated/shipping/'
    | '/_authenticated/stocks/'
    | '/_authenticated/tracking-states/'
    | '/_authenticated/villes/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/privacy",
        "/terms",
        "/(auth)/forgot-password",
        "/(auth)/sign-in",
        "/(auth)/sign-in-2",
        "/(auth)/sign-up",
        "/(errors)/401",
        "/(errors)/403",
        "/(errors)/404",
        "/(errors)/500",
        "/(errors)/503"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/api-settings",
        "/_authenticated/settings",
        "/_authenticated/",
        "/_authenticated/affectation/",
        "/_authenticated/announces/",
        "/_authenticated/apps/",
        "/_authenticated/bon-livraison/",
        "/_authenticated/bon-retour-client/",
        "/_authenticated/bon-retour-livreur/",
        "/_authenticated/chats/",
        "/_authenticated/clients-fee/",
        "/_authenticated/clients/",
        "/_authenticated/commands-change/",
        "/_authenticated/commands-echoue/",
        "/_authenticated/commands-en-cours/",
        "/_authenticated/commands-livres/",
        "/_authenticated/commands-sans-livreur/",
        "/_authenticated/commands-updated-today/",
        "/_authenticated/commands/",
        "/_authenticated/factures-clients/",
        "/_authenticated/factures-livraison/",
        "/_authenticated/help-center/",
        "/_authenticated/livreurs-fee/",
        "/_authenticated/livreurs/",
        "/_authenticated/moderateurs/",
        "/_authenticated/packaging/",
        "/_authenticated/rammasage/",
        "/_authenticated/shipping/",
        "/_authenticated/stocks/",
        "/_authenticated/tracking-states/",
        "/_authenticated/villes/"
      ]
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/terms": {
      "filePath": "terms.tsx"
    },
    "/_authenticated/api-settings": {
      "filePath": "_authenticated/api-settings/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/api-settings/doc",
        "/_authenticated/api-settings/keys"
      ]
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/account",
        "/_authenticated/settings/appearance",
        "/_authenticated/settings/display",
        "/_authenticated/settings/notifications",
        "/_authenticated/settings/"
      ]
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.tsx"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx"
    },
    "/(auth)/sign-in-2": {
      "filePath": "(auth)/sign-in-2.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.tsx"
    },
    "/(errors)/401": {
      "filePath": "(errors)/401.tsx"
    },
    "/(errors)/403": {
      "filePath": "(errors)/403.tsx"
    },
    "/(errors)/404": {
      "filePath": "(errors)/404.tsx"
    },
    "/(errors)/500": {
      "filePath": "(errors)/500.tsx"
    },
    "/(errors)/503": {
      "filePath": "(errors)/503.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/api-settings/doc": {
      "filePath": "_authenticated/api-settings/doc.tsx",
      "parent": "/_authenticated/api-settings"
    },
    "/_authenticated/api-settings/keys": {
      "filePath": "_authenticated/api-settings/keys.tsx",
      "parent": "/_authenticated/api-settings"
    },
    "/_authenticated/settings/account": {
      "filePath": "_authenticated/settings/account.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/appearance": {
      "filePath": "_authenticated/settings/appearance.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/display": {
      "filePath": "_authenticated/settings/display.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/notifications": {
      "filePath": "_authenticated/settings/notifications.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/affectation/": {
      "filePath": "_authenticated/affectation/index.ts",
      "parent": "/_authenticated"
    },
    "/_authenticated/announces/": {
      "filePath": "_authenticated/announces/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/apps/": {
      "filePath": "_authenticated/apps/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/bon-livraison/": {
      "filePath": "_authenticated/bon-livraison/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/bon-retour-client/": {
      "filePath": "_authenticated/bon-retour-client/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/bon-retour-livreur/": {
      "filePath": "_authenticated/bon-retour-livreur/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/chats/": {
      "filePath": "_authenticated/chats/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/clients-fee/": {
      "filePath": "_authenticated/clients-fee/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/clients/": {
      "filePath": "_authenticated/clients/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-change/": {
      "filePath": "_authenticated/commands-change/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-echoue/": {
      "filePath": "_authenticated/commands-echoue/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-en-cours/": {
      "filePath": "_authenticated/commands-en-cours/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-livres/": {
      "filePath": "_authenticated/commands-livres/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-sans-livreur/": {
      "filePath": "_authenticated/commands-sans-livreur/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands-updated-today/": {
      "filePath": "_authenticated/commands-updated-today/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/commands/": {
      "filePath": "_authenticated/commands/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/factures-clients/": {
      "filePath": "_authenticated/factures-clients/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/factures-livraison/": {
      "filePath": "_authenticated/factures-livraison/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/help-center/": {
      "filePath": "_authenticated/help-center/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/livreurs-fee/": {
      "filePath": "_authenticated/livreurs-fee/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/livreurs/": {
      "filePath": "_authenticated/livreurs/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/moderateurs/": {
      "filePath": "_authenticated/moderateurs/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/packaging/": {
      "filePath": "_authenticated/packaging/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/rammasage/": {
      "filePath": "_authenticated/rammasage/index.ts",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/shipping/": {
      "filePath": "_authenticated/shipping/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/stocks/": {
      "filePath": "_authenticated/stocks/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/tracking-states/": {
      "filePath": "_authenticated/tracking-states/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/villes/": {
      "filePath": "_authenticated/villes/index.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
